<template>
  <div class="dvLoader-container animate_loaderOut bodyLoader">
    <div class="dvLoader-bar">
      <v-progress-linear
        indeterminate
        background-color="#757575"
        color="#18FFFF"
        height="5"
        absolute
        top
      ></v-progress-linear>
    </div>

    <div class="dvLoader-circular animate_loader fadeIn">
      <v-progress-circular
        :size="45"
        :width="3"
        color="#CCCCCC"
        indeterminate
      ></v-progress-circular>
    </div>
  </div> <!-- dvLoader-container-->

</template>

<script>
  export default {
    name: 'body-loader',
    props: ['loading'],
    data: () => ({
    }),
    watch: {
      loading: function() {
        let self = this
        if(!this.loading){
          setTimeout(function(){
            self.$jQuery(".bodyLoader").fadeOut();
          }, 200);
        }else{
          self.$jQuery(".bodyLoader").show();
        }
      }
    },
    computed: {
    },
    methods: {
    },
    mounted() {
    },
    created () {
    },
    components: {
    }
  }
</script>
